<template>
  <v-row no-gutters justify="center">
    <v-col cols="12">
      <v-card
        elevation="0"
        class="px-4 pb-4 searchResultFinder d-flex justify-space-between flex-column"
        min-height="280"
      >
        <v-row no-gutters class="px-5 d-flex justify-center">
          <v-col cols="12" class="col-md-8">
            <v-row no-gutters>
              <v-col cols="12">
                <v-checkbox
                  class="margin-top-checkbox mb-md-4 mb-3 radioLabel text-subtitle-1"
                  hide-details="auto"
                  @change="updateStatus"
                  v-model="dataPlayer.status"
                  true-value="active"
                  false-value="inactive"
                  color="primary"
                >
                <template slot="label">
                  {{$gettext('Available right now')}}
                  <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on"
                      class="fal fa-circle-info ml-1" color="#F2C94C"
                      size="12"
                    ></v-icon>
                  </template>
                  <span v-translate>By picking up here, you are no longer available for this moment to participate in these activities </span>
                </v-tooltip>
                </template>
                </v-checkbox>
              </v-col>
              <v-col cols="12" md="6" sm="6" class="pt-5">
                <v-row no-gutters class="pb-4">
                  <v-col cols="6" md="4">
                    <span v-translate class="font-weight-bold"
                      >Country</span
                    ></v-col
                  >
                  <v-col cols="6" md="8">
                    <span>
                      :
                      {{
                        (currentPlayer.country && currentPlayer.country.name) ||
                          ""
                      }}</span
                    >
                  </v-col>
                </v-row>

                <v-row no-gutters class="pb-4">
                  <v-col cols="6" md="4">
                    <span v-translate class="font-weight-bold"
                      >State</span
                    ></v-col
                  >
                  <v-col cols="6" md="8">
                    <span>
                      :
                      {{
                        (currentPlayer.state && currentPlayer.state.name) || ""
                      }}</span
                    >
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="6" md="4">
                    <span v-translate class="font-weight-bold"
                      >City</span
                    ></v-col
                  >
                  <v-col cols="6" md="8">
                    <span>
                      :
                      {{
                        (currentPlayer.city && currentPlayer.city.name) || ""
                      }}</span
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="my-9">
                <label class="font-weight-bold text-subtitle-1"
                  ><translate
                    >Which Golf course are you ready to play ?</translate
                  ></label
                >
                <ul>
                  <li v-for="(item, idx) in currentPlayer.courses" :key="idx">
                    <i class="fas fa-circle fa-small fa-xs"></i>{{ item.name }}
                  </li>
                </ul>
              </v-col>
              <v-col cols="12" class="mb-9">
                <label class="font-weight-bold text-subtitle-1"
                  ><translate>Availabilities</translate></label
                >
                <ul>
                  <li v-if="currentPlayer.mondayFrom">
                    <i class="fas fa-circle fa-small fa-xs"></i> <translate>Monday</translate> ({{
                      currentPlayer.mondayFrom
                    }}
                    - {{ currentPlayer.mondayTo }})
                  </li>
                  <li v-if="currentPlayer.tuesdayFrom">
                    <i class="fas fa-circle fa-small fa-xs"></i> <translate>Tuesday</translate> ({{
                      currentPlayer.tuesdayFrom
                    }}
                    - {{ currentPlayer.tuesdayTo }})
                  </li>
                  <li v-if="currentPlayer.wednesdayFrom">
                    <i class="fas fa-circle fa-small fa-xs"></i> <translate>Wednesday</translate> ({{
                      currentPlayer.wednesdayFrom
                    }}
                    - {{ currentPlayer.wednesdayTo }})
                  </li>
                  <li v-if="currentPlayer.thursdayFrom">
                    <i class="fas fa-circle fa-small fa-xs"></i> <translate>Thursday</translate> ({{
                      currentPlayer.thursdayFrom
                    }}
                    - {{ currentPlayer.thursdayTo }})
                  </li>
                  <li v-if="currentPlayer.fridayFrom">
                    <i class="fas fa-circle fa-small fa-xs"></i> <translate>Friday</translate> ({{
                      currentPlayer.fridayFrom
                    }}
                    - {{ currentPlayer.fridayTo }})
                  </li>
                  <li v-if="currentPlayer.saturdayFrom">
                    <i class="fas fa-circle fa-small fa-xs"></i> <translate>Saturday</translate> ({{
                      currentPlayer.saturdayFrom
                    }}
                    - {{ currentPlayer.saturdayTo }})
                  </li>
                  <li v-if="currentPlayer.sundayFrom">
                    <i class="fas fa-circle fa-small fa-xs"></i> <translate>Sunday</translate> ({{
                      currentPlayer.sundayFrom
                    }}
                    - {{ currentPlayer.sundayTo }})
                  </li>
                </ul>
                <ul v-if="currentPlayer.timeTemporary && currentPlayer.timeTemporary.length !== 0">
                  <li v-for="(item, index) in currentPlayer.timeTemporary" :key="index">
                    <i class="fas fa-circle fa-small fa-xs"></i> {{item[0]}} ({{
                      item[1]
                    }}
                    - {{ item[2]}})
                  </li>
                </ul>
              </v-col>
              <v-col cols="12">
                <v-btn
                  x-large
                  type="submit"
                  color="primary"
                  class="font-weight-bold elevation-0 text-none subtitle-1 px-4 py-5 btn-square"
                  @click="$emit('edit')"
                >
                  <translate>Edit</translate>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import DatePickerInput from "@/components/Common/DatePickerInput";
import ButtonEdit from "@/components/Buttons/ButtonEdit";
import PlayerFinder from "@/services/PlayerFinder";
export default {
  components: {
    DatePickerInput,
    ButtonEdit
  },
  props: {
    currentPlayer: {}
  },
  data() {
    return {
      dataPlayer: {}
    };
  },
  methods: {
    async onSubmit() {
      let data = {};
      const result = await this.$store.dispatch("updateFormHost", data);
      if (result.error) {
        this.$toast.alert(result.error.message);
      } else {
        const text = this.$gettext("success");
        this.$toast.success(text);
      }
    },
    async updateStatus() {
      let response = null
      if(this.currentPlayer.status === 'active') {
        response = await PlayerFinder.inactive();
      } else {
        response = await PlayerFinder.active();
      }
      if(response.error) {
        this.$toast.alert(response.error.message);
      } else {
        this.$toast.success(response.result);
      }
    }
  },
  mounted() {
    if(this.currentPlayer.courses.length !== 0)
    this.dataPlayer = JSON.parse(JSON.stringify(this.currentPlayer))
  }
};
</script>